// Stacked bar (8 px pill) of segments with token colours and an accessible text summary; zero segments are skipped.
import { cn } from "@/lib/cn";
import { formatNumber } from "@/lib/format";

export interface StackSegment {
  key: string;
  label: string;
  value: number;
  color: string;
}

interface StackBarProps {
  segments: readonly StackSegment[];
  total?: number;
  label: string;
  className?: string;
}

export function StackBar({ segments, total, label, className }: StackBarProps) {
  const sum = total ?? segments.reduce((acc, segment) => acc + segment.value, 0);
  const summary = segments.map((segment) => `${formatNumber(segment.value)} ${segment.label}`).join(", ");
  return (
    <div
      role="img"
      aria-label={`${label}: ${summary}`}
      className={cn("flex h-2 gap-0.5 overflow-hidden rounded-pill bg-track", className)}
    >
      {sum > 0
        ? segments
            .filter((segment) => segment.value > 0)
            .map((segment) => (
              <i
                key={segment.key}
                className="block h-full"
                style={{ width: `${(segment.value / sum) * 100}%`, background: segment.color }}
              />
            ))
        : null}
    </div>
  );
}
